// Stadium mappings for teams
export const TEAM_STADIUM_MAPPINGS: { [key: string]: string } = {
  // Premier League
  'Arsenal': 'Emirates Stadium',
  'Arsenal FC': 'Emirates Stadium',
  'Aston Villa': 'Villa Park',
  'Aston Villa FC': 'Villa Park',
  'Brentford': 'Brentford Community Stadium',
  'Brentford FC': 'Brentford Community Stadium',
  'Brighton & Hove Albion': 'American Express Community Stadium',
  'Brighton & Hove Albion FC': 'American Express Community Stadium',
  'Burnley': 'Turf Moor',
  'Burnley FC': 'Turf Moor',
  'Chelsea': 'Stamford Bridge',
  'Chelsea FC': 'Stamford Bridge',
  'Crystal Palace': 'Selhurst Park',
  'Crystal Palace FC': 'Selhurst Park',
  'Everton': 'Goodison Park',
  'Everton FC': 'Goodison Park',
  'Fulham': 'Craven Cottage',
  'Fulham FC': 'Craven Cottage',
  'Leeds United': 'Elland Road',
  'Leeds United FC': 'Elland Road',
  'Leicester City': 'King Power Stadium',
  'Leicester City FC': 'King Power Stadium',
  'Liverpool': 'Anfield',
  'Liverpool FC': 'Anfield',
  'Manchester City': 'Etihad Stadium',
  'Manchester City FC': 'Etihad Stadium',
  'Manchester United': 'Old Trafford',
  'Manchester United FC': 'Old Trafford',
  'Newcastle United': 'St James\' Park',
  'Newcastle United FC': 'St James\' Park',
  'Norwich City': 'Carrow Road',
  'Norwich City FC': 'Carrow Road',
  'Sheffield United': 'Bramall Lane',
  'Sheffield United FC': 'Bramall Lane',
  'Southampton': 'St Mary\'s Stadium',
  'Southampton FC': 'St Mary\'s Stadium',
  'Tottenham Hotspur': 'Tottenham Hotspur Stadium',
  'Tottenham Hotspur FC': 'Tottenham Hotspur Stadium',
  'Watford': 'Vicarage Road',
  'Watford FC': 'Vicarage Road',
  'West Bromwich Albion': 'The Hawthorns',
  'West Bromwich Albion FC': 'The Hawthorns',
  'West Ham United': 'London Stadium',
  'West Ham United FC': 'London Stadium',
  'Wolverhampton Wanderers': 'Molineux Stadium',
  'Wolverhampton Wanderers FC': 'Molineux Stadium',
  'Wolves': 'Molineux Stadium',
  'AFC Bournemouth': 'Vitality Stadium',
  'Bournemouth': 'Vitality Stadium',
  'Nottingham Forest': 'The City Ground',
  'Nottingham Forest FC': 'The City Ground',
  'Luton Town': 'Kenilworth Road',
  'Luton Town FC': 'Kenilworth Road',
  'Ipswich Town': 'Portman Road',
  'Ipswich Town FC': 'Portman Road',

  // Championship / Other English
  'Sunderland': 'Stadium of Light',
  'Sunderland AFC': 'Stadium of Light',
  'Middlesbrough': 'Riverside Stadium',
  'Middlesbrough FC': 'Riverside Stadium',
  'Coventry City': 'Coventry Building Society Arena',
  'Coventry City FC': 'Coventry Building Society Arena',

  // La Liga
  'FC Barcelona': 'Camp Nou',
  'Barcelona': 'Camp Nou',
  'Real Madrid': 'Santiago Bernabéu',
  'Real Madrid CF': 'Santiago Bernabéu',
  'Atlético Madrid': 'Wanda Metropolitano',
  'Club Atlético de Madrid': 'Wanda Metropolitano',
  'Atletico Madrid': 'Wanda Metropolitano',
  'Athletic Bilbao': 'San Mamés',
  'Athletic Club': 'San Mamés',
  'Real Betis': 'Estadio Benito Villamarín',
  'Real Betis Balompié': 'Estadio Benito Villamarín',
  'Sevilla': 'Ramón Sánchez-Pizjuán',
  'Sevilla FC': 'Ramón Sánchez-Pizjuán',
  'Valencia': 'Mestalla',
  'Valencia CF': 'Mestalla',
  'Villarreal': 'Estadio de la Cerámica',
  'Villarreal CF': 'Estadio de la Cerámica',
  'Real Sociedad': 'Reale Arena',
  'Getafe': 'Coliseum Alfonso Pérez',
  'Getafe CF': 'Coliseum Alfonso Pérez',
  'Espanyol': 'RCDE Stadium',
  'RCD Espanyol': 'RCDE Stadium',
  'Celta Vigo': 'Estadio Municipal de Balaídos',
  'RC Celta de Vigo': 'Estadio Municipal de Balaídos',
  'Alavés': 'Estadio de Mendizorrotza',
  'Deportivo Alavés': 'Estadio de Mendizorrotza',
  'Osasuna': 'Estadio El Sadar',
  'CA Osasuna': 'Estadio El Sadar',
  'Mallorca': 'Estadi de Son Moix',
  'RCD Mallorca': 'Estadi de Son Moix',
  'Rayo Vallecano': 'Estadio de Vallecas',
  'Girona': 'Estadi Municipal de Montilivi',
  'Girona FC': 'Estadi Municipal de Montilivi',
  'Elche': 'Estadio Martínez Valero',
  'Elche CF': 'Estadio Martínez Valero',
  'Las Palmas': 'Estadio Gran Canaria',
  'UD Las Palmas': 'Estadio Gran Canaria',
  'Cádiz': 'Estadio Nuevo Mirandilla',
  'Cádiz CF': 'Estadio Nuevo Mirandilla',
  'Levante': 'Estadio Ciudad de Valencia',
  'Levante UD': 'Estadio Ciudad de Valencia',
  'Leganés': 'Estadio Municipal de Butarque',
  'CD Leganés': 'Estadio Municipal de Butarque',

  // Serie A
  'AC Milan': 'San Siro',
  'Milan': 'San Siro',
  'Inter Milan': 'San Siro',
  'Internazionale': 'San Siro',
  'Juventus': 'Allianz Stadium',
  'Juventus FC': 'Allianz Stadium',
  'AS Roma': 'Stadio Olimpico',
  'Roma': 'Stadio Olimpico',
  'Lazio': 'Stadio Olimpico',
  'SS Lazio': 'Stadio Olimpico',
  'Napoli': 'Stadio Diego Armando Maradona',
  'SSC Napoli': 'Stadio Diego Armando Maradona',
  'Atalanta': 'Gewiss Stadium',
  'Atalanta BC': 'Gewiss Stadium',
  'Fiorentina': 'Stadio Artemio Franchi',
  'ACF Fiorentina': 'Stadio Artemio Franchi',

  // Bundesliga
  'Bayern Munich': 'Allianz Arena',
  'FC Bayern München': 'Allianz Arena',
  'Borussia Dortmund': 'Signal Iduna Park',
  'BVB': 'Signal Iduna Park',
  'RB Leipzig': 'Red Bull Arena',
  'Bayer Leverkusen': 'BayArena',
  'Bayer 04 Leverkusen': 'BayArena',
  'Eintracht Frankfurt': 'Deutsche Bank Park',
  'VfB Stuttgart': 'Mercedes-Benz Arena',
  'Schalke 04': 'Veltins-Arena',
  'FC Schalke 04': 'Veltins-Arena',

  // Ligue 1
  'Paris Saint-Germain': 'Parc des Princes',
  'PSG': 'Parc des Princes',
  'Marseille': 'Orange Vélodrome',
  'Olympique de Marseille': 'Orange Vélodrome',
  'Lyon': 'Groupama Stadium',
  'Olympique Lyonnais': 'Groupama Stadium',
  'Monaco': 'Stade Louis II',
  'AS Monaco': 'Stade Louis II',
  'Lille': 'Stade Pierre-Mauroy',
  'LOSC Lille': 'Stade Pierre-Mauroy',

  // Eredivisie
  'Ajax': 'Johan Cruijff Arena',
  'AFC Ajax': 'Johan Cruijff Arena',
  'PSV Eindhoven': 'Philips Stadion',
  'PSV': 'Philips Stadion',
  'Feyenoord': 'De Kuip',
  'AZ Alkmaar': 'AFAS Stadion',
  'AZ': 'AFAS Stadion',

  // Other European
  'Benfica': 'Estádio da Luz',
  'SL Benfica': 'Estádio da Luz',
  'Porto': 'Estádio do Dragão',
  'FC Porto': 'Estádio do Dragão',
  'Sporting CP': 'Estádio José Alvalade',
  'Sporting': 'Estádio José Alvalade',
  'Celtic': 'Celtic Park',
  'Celtic FC': 'Celtic Park',
  'Rangers': 'Ibrox Stadium',
  'Rangers FC': 'Ibrox Stadium',
  'Galatasaray': 'Türk Telekom Stadium',
  'Fenerbahçe': 'Ülker Stadium',
  'Besiktas': 'Vodafone Park',
  'Beşiktaş': 'Vodafone Park',
};

/**
 * Get the stadium name for a team
 * @param teamName - The name of the team
 * @returns The stadium name or a default stadium name
 */
export function getStadiumForTeam(teamName: string): string {
  // Try exact match first
  if (TEAM_STADIUM_MAPPINGS[teamName]) {
    return TEAM_STADIUM_MAPPINGS[teamName];
  }
  
  // Try case-insensitive match
  const normalizedTeamName = teamName.toLowerCase();
  for (const [key, value] of Object.entries(TEAM_STADIUM_MAPPINGS)) {
    if (key.toLowerCase() === normalizedTeamName) {
      return value;
    }
  }
  
  // Try partial match (contains)
  for (const [key, value] of Object.entries(TEAM_STADIUM_MAPPINGS)) {
    if (normalizedTeamName.includes(key.toLowerCase()) || key.toLowerCase().includes(normalizedTeamName)) {
      return value;
    }
  }
  
  // Default fallback - clean the team name and add Stadium
  const cleanedName = teamName
    .replace(/ FC$/i, '')
    .replace(/ CF$/i, '')
    .replace(/ SC$/i, '')
    .replace(/ AFC$/i, '')
    .replace(/ AC$/i, '')
    .replace(/ BC$/i, '')
    .replace(/ UD$/i, '')
    .replace(/ CD$/i, '')
    .trim();
  
  return `${cleanedName} Stadium`;
}

// Stadium to country mappings
export const STADIUM_COUNTRY_MAPPINGS: { [key: string]: string } = {
  // England - Premier League
  'Emirates Stadium': 'England',
  'Villa Park': 'England',
  'Brentford Community Stadium': 'England',
  'American Express Community Stadium': 'England',
  'Turf Moor': 'England',
  'Stamford Bridge': 'England',
  'Selhurst Park': 'England',
  'Goodison Park': 'England',
  'Craven Cottage': 'England',
  'Elland Road': 'England',
  'King Power Stadium': 'England',
  'Anfield': 'England',
  'Etihad Stadium': 'England',
  'Old Trafford': 'England',
  'St James\' Park': 'England',
  'Carrow Road': 'England',
  'Bramall Lane': 'England',
  'St Mary\'s Stadium': 'England',
  'Tottenham Hotspur Stadium': 'England',
  'Vicarage Road': 'England',
  'The Hawthorns': 'England',
  'London Stadium': 'England',
  'Molineux Stadium': 'England',
  'Vitality Stadium': 'England',
  'The City Ground': 'England',
  'Kenilworth Road': 'England',
  'Portman Road': 'England',
  'Stadium of Light': 'England',
  'Riverside Stadium': 'England',
  'Coventry Building Society Arena': 'England',
  
  // Spain - La Liga
  'Camp Nou': 'Spain',
  'Santiago Bernabéu': 'Spain',
  'Wanda Metropolitano': 'Spain',
  'San Mamés': 'Spain',
  'Estadio Benito Villamarín': 'Spain',
  'Ramón Sánchez-Pizjuán': 'Spain',
  'Mestalla': 'Spain',
  'Estadio de la Cerámica': 'Spain',
  'Reale Arena': 'Spain',
  'Coliseum Alfonso Pérez': 'Spain',
  'RCDE Stadium': 'Spain',
  'Estadio Municipal de Balaídos': 'Spain',
  'Estadio de Mendizorrotza': 'Spain',
  'Estadio El Sadar': 'Spain',
  'Estadi de Son Moix': 'Spain',
  'Estadio de Vallecas': 'Spain',
  'Estadi Municipal de Montilivi': 'Spain',
  'Estadio Martínez Valero': 'Spain',
  'Estadio Gran Canaria': 'Spain',
  'Estadio Nuevo Mirandilla': 'Spain',
  'Estadio Ciudad de Valencia': 'Spain',
  'Estadio Municipal de Butarque': 'Spain',
  
  // Italy - Serie A
  'San Siro': 'Italy',
  'Allianz Stadium': 'Italy',
  'Stadio Olimpico': 'Italy',
  'Stadio Diego Armando Maradona': 'Italy',
  'Gewiss Stadium': 'Italy',
  'Stadio Artemio Franchi': 'Italy',
  
  // Germany - Bundesliga
  'Allianz Arena': 'Germany',
  'Signal Iduna Park': 'Germany',
  'Red Bull Arena': 'Germany',
  'BayArena': 'Germany',
  'Deutsche Bank Park': 'Germany',
  'Mercedes-Benz Arena': 'Germany',
  'Veltins-Arena': 'Germany',
  
  // France - Ligue 1
  'Parc des Princes': 'France',
  'Orange Vélodrome': 'France',
  'Groupama Stadium': 'France',
  'Stade Louis II': 'Monaco',
  'Stade Pierre-Mauroy': 'France',
  
  // Netherlands - Eredivisie
  'Johan Cruijff Arena': 'Netherlands',
  'Philips Stadion': 'Netherlands',
  'De Kuip': 'Netherlands',
  'AFAS Stadion': 'Netherlands',
  
  // Portugal
  'Estádio da Luz': 'Portugal',
  'Estádio do Dragão': 'Portugal',
  'Estádio José Alvalade': 'Portugal',
  
  // Scotland
  'Celtic Park': 'Scotland',
  'Ibrox Stadium': 'Scotland',
  
  // Turkey
  'Türk Telekom Stadium': 'Turkey',
  'Ülker Stadium': 'Turkey',
  'Vodafone Park': 'Turkey',
};

/**
 * Get the country for a stadium
 * @param stadiumName - The name of the stadium
 * @returns The country name or 'England' as default
 */
export function getCountryForStadium(stadiumName: string): string {
  if (STADIUM_COUNTRY_MAPPINGS[stadiumName]) {
    return STADIUM_COUNTRY_MAPPINGS[stadiumName];
  }
  
  // Try case-insensitive match
  const normalizedStadiumName = stadiumName.toLowerCase();
  for (const [key, value] of Object.entries(STADIUM_COUNTRY_MAPPINGS)) {
    if (key.toLowerCase() === normalizedStadiumName) {
      return value;
    }
  }
  
  // Default to England for unknown stadiums (most common in the app)
  return 'England';
}